import React from 'react';
import { formatCurrency, formatWeight } from '../../../../../utils/format';
import { MODO_IMPRESSAO } from '~/constants';

const moeda = (valor, impressaoA4) => impressaoA4 ? formatCurrency(valor) : formatCurrency(valor).replace('R$ ', 'R$');

const TotalizersSection = ({ documento, modoImpressao }) => {
  const itens = documento?.itens || [];
  const desconto = itens.reduce((total, item) => total + (item?.itemValorDesconto || 0), 0);
  const acrescimo = itens.reduce((total, item) => total + (item?.itemValorAcrescimo || 0), 0);
  const frete = itens.reduce((total, item) => total + (item?.itemValorFrete || 0), 0);
  const seguro = itens.reduce((total, item) => total + (item?.itemValorSeguro || 0), 0);
  const despesa = itens.reduce((total, item) => total + (item?.itemValorDespesa || 0), 0);
  const valorTotal = documento?.valorTotal || 0;
  const impressaoA4 = modoImpressao === MODO_IMPRESSAO.A4;
  const pesoLiquidoCalculado = itens.reduce((total, item) => total + Number(item?.produtoEstProduto?.pesoLiquido || item?.produtoPesoLiquido || 0) * Number(item?.itemQuantidade || 0), 0);
  const pesoBrutoCalculado = itens.reduce((total, item) => total + Number(item?.produtoEstProduto?.pesoBruto || item?.produtoPesoBruto || 0) * Number(item?.itemQuantidade || 0), 0);
  const pesoLiquido = Number(documento?.transpVolPesoLiquido) > 0 ? Number(documento.transpVolPesoLiquido) : pesoLiquidoCalculado;
  const pesoBruto = Number(documento?.transpVolPesoBruto) > 0 ? Number(documento.transpVolPesoBruto) : pesoBrutoCalculado;
  const pesos = [
    { label: impressaoA4 ? 'Peso Líquido:' : 'P. Líq.:', value: pesoLiquido },
    { label: impressaoA4 ? 'Peso Bruto:' : 'P. Bruto:', value: pesoBruto },
  ];
  const pesoFontSize = 'var(--small-text-size)';
  const totalizadores = [
    { label: 'Subtotal:', value: valorTotal + desconto - acrescimo - frete },
    { label: 'Desconto:', value: desconto },
    { label: 'Acréscimo:', value: acrescimo },
    { label: 'Frete:', value: frete },
    { label: 'Seguro:', value: seguro },
    { label: 'Despesa:', value: despesa },
    { label: impressaoA4 ? 'Total:' : 'TOTAL', value: valorTotal },
  ];

  const ultimo = totalizadores.at(-1);
  const restante = totalizadores.slice(0, -1);
  const qtdColunas = impressaoA4 ? 1 : 2;
  const tamanhoColuna = Math.ceil(restante.length / qtdColunas);
  const colunas = Array.from({ length: qtdColunas }, (_, index) =>
    restante.slice(
      index * tamanhoColuna,
      (index + 1) * tamanhoColuna
    )
  );

  return (
    <div
      className='no-break scrollable'
      style={{
        justifyContent: 'space-evenly',
        padding: impressaoA4 ? 'var(--spacing-size)' : 'var(--half-spacing-size) var(--spacing-size)',
        fontSize: 'var(--regular-text-size)',
        display: 'grid',
        gridTemplateColumns: `repeat(${qtdColunas}, auto)`,
        rowGap: 'var(--vertical-item-grid-spacing)',
        columnGap: 'var(--spacing-size)',
        overflowX: 'auto'
      }}
    >
      {impressaoA4 && (
        <div style={{ gridColumn: '1 / -1', fontWeight: '700', fontSize: 'var(--section-title-text-size)', paddingBottom: 'var(--half-spacing-size)', textAlign: 'center' }}>
          TOTALIZADORES
        </div>
      )}

      {colunas.map((coluna, colIdx) => (
        <div
          key={colIdx}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            width: '100%',
            ...(!impressaoA4 && { gap: 'var(--spacing-size)' }),
          }}
        >
          {coluna.map(({ label, value }, idx) => (
            <div
              key={idx}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: 'var(--horizontal-item-grid-spacing)',
              }}
            >
              <span style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', fontWeight: !impressaoA4 ? '700' : undefined }}>{label}</span>
              <span style={{ verticalAlign: 'top', textAlign: 'right', whiteSpace: 'nowrap', fontWeight: !impressaoA4 ? undefined : '700' }}>{moeda(value, impressaoA4)}</span>
            </div>
          ))}
        </div>
      ))}
      {impressaoA4 && (
        <>
          <div style={{ gridColumn: '1 / -1', display: 'flex', flexDirection: 'column' }}>
            {pesos.map(({ label, value }) => (
              <div key={label} style={{ display: 'flex', justifyContent: 'space-between', gap: 'var(--horizontal-item-grid-spacing)', fontSize: pesoFontSize, fontWeight: '700' }}>
                <span style={{ whiteSpace: 'nowrap' }}>{label}</span>
                <span style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>{formatWeight(value)}</span>
              </div>
            ))}
          </div>
          <div style={{ gridColumn: '1 / -1', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 'var(--horizontal-item-grid-spacing)', fontWeight: '700' }}>
              <span style={{ whiteSpace: 'nowrap' }}>{ultimo.label}</span>
              <span style={{ fontSize: 'var(--section-title-text-size)', verticalAlign: 'top', whiteSpace: 'nowrap', textAlign: 'right' }}>{moeda(ultimo.value, impressaoA4)}</span>
            </div>
          </div>
        </>
      )}
      {!impressaoA4 && (
        <div
          style={{
            gridColumn: '1 / -1',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
            gap: 'var(--horizontal-item-grid-spacing)',
            marginTop: 'var(--half-spacing-size)',
            borderTop: '1px solid rgba(128, 128, 128, 0.35)',
            paddingTop: 'var(--half-spacing-size)',
          }}
        >
          <div style={{ display: 'flex', gap: 'var(--spacing-size)', fontSize: pesoFontSize, fontWeight: '700' }}>
            {pesos.map(({ label, value }) => (
              <span key={label} style={{ whiteSpace: 'nowrap' }}>{label} {formatWeight(value)}</span>
            ))}
          </div>
          <div style={{ alignSelf: 'stretch', borderLeft: '1px solid rgba(128, 128, 128, 0.35)', marginTop: '3px', marginBottom: '2px' }} />
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 'var(--horizontal-item-grid-spacing)' }}>
            <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', fontWeight: '700' }}>{ultimo.label}</span>
            <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'right', whiteSpace: 'nowrap', fontWeight: '700' }}>{moeda(ultimo.value, impressaoA4)}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TotalizersSection;
